import { render } from "./stars.vue?vue&type=template&id=5ec2039b"
import script from "./stars.vue?vue&type=script&lang=js"
export * from "./stars.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__